import React, { useEffect, useState, useRef } from "react";
import * as api from "./../../api/api";
import * as c from "./../../const";

import CloudDoneIcon from "@material-ui/icons/CloudDone";
import CloudIcon from "@material-ui/icons/Cloud";
import LibraryAddCheckIcon from "@material-ui/icons/LibraryAddCheck";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

//React-Window
import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from "react-virtualized";

//PAGINATION
import Pagination from "@material-ui/lab/Pagination";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

export default function AdminDashboard(props) {
  const cache = useRef(
    new CellMeasurerCache({
      fixedHeight: true,
      defaultHeight: 100,
    })
  );
  const classes = useStyles();

  const [loader, setLoader] = useState(true);
  const [unpublished, setUnpublished] = useState("0");
  const [published, setPublished] = useState("0");

  const id = props.id;

  useEffect(() => {
    const sponsorPostApi = async () => {
      try {
        let response = await api.sponsorPost(id);
        if (response.data) {
          setPosts(response.data);
          setLoader(false);
        }
      } catch (e) {}
    };

    const getCountApi = async () => {
      try {
        let response = await api.postCount(id);
        setPublished(response.published);
        setUnpublished(response.unpublished);
      } catch (e) {}
    };
    if (!id) {
      return false;
    }
    sponsorPostApi();
    getCountApi();
  }, []);

  const [posts, setPosts] = useState("");

  const [N, setN] = useState(1);
  const from = Number((N - 1) * 10 - 1);
  const till = Number(N * 10 - 1);
  const length = Math.ceil(posts.length / 10);

  const total = Number(published) + Number(unpublished);

  return (
    <div className="main-panel mr-2">
      <div className="content-wrapper">
        <div className="row">
          <div className="col-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Current Status</h4>
                <div className="d-flex justify-content-between mb-3 flex-column flex-lg-row">
                  <div className="py-2">
                    <LibraryAddCheckIcon className="mr-2" />
                    <span>Total Posts: </span>
                    <span>{total}</span>
                  </div>
                  <div className="py-2">
                    <CloudDoneIcon color="primary" className="mr-2" />
                    <span>Published Posts: </span>
                    <span>{published}</span>
                  </div>
                  <div className="py-2">
                    <CloudIcon className="mr-2" />
                    <span>Un-published Posts: </span>
                    <span>{unpublished}</span>
                  </div>
                </div>

                <div>
                  {/* <AutoSizer>
                    {({width, height}) =>(
                    <List
                        width={1100}
                        height={1000}
                        rowCount={posts.length}
                        rowHeight={cache.current.rowHeight}
                        deferredMeasurementCache={cache.current}
                        overscanRowCount={4}
                        rowRenderer={({ key, index, style, parent }) => {
                          const src = `${c.URL}/${posts[index].image[0]}`;
                          const title = posts[index].title;
                          const desc = posts[index].details;
                          const id = posts[index].id;
                          return (
                            <CellMeasurerCache 
                              key={key} 
                              cache={cache.current} 
                              parent={parent} 
                              columnIndex={0} 
                              rowIndex={index}
                            >
                              <div className="d-flex mt-5 align-items-top flex-wrap flex-lg-nowrap" style={style}>
                                <img
                                  src={src}
                                  className="img-sm rounded-circle mr-3"
                                  alt="blogImage"
                                />
                                <div className="mb-0 flex-grow">
                                  <h5 className="mr-2 mb-2">{title}</h5>
                                  <span
                                    className="mb-0 font-weight-light "
                                    dangerouslySetInnerHTML={{
                                      __html: desc,
                                    }}
                                  ></span>
                                </div>
                                <div className="ml-auto">
                                  <i className="mdi mdi-heart-outline text-muted"></i>
                                </div>
                              </div>
                            </CellMeasurerCache>
                          );
                        }}
                      />)}
                  </AutoSizer> */}
                  {Object.keys(posts).map((index) => {
                    const url = c.URL;
                    let src = `${url}/${posts[index].image[0]}`;
                    if (index > from && index <= till) {
                      return (
                        <div
                          className="d-flex mt-5 align-items-top flex-wrap flex-lg-nowrap"
                          style={{ wordBreak: "break-word" }}
                        >
                          <img
                            src={src}
                            className="img-sm rounded-circle mr-3"
                            alt="blogImage"
                          />
                          <div className="mb-0 flex-grow">
                            <h5 className="mr-2 mb-2">{posts[index].title}</h5>
                            <span
                              className="mb-0 font-weight-light "
                              dangerouslySetInnerHTML={{
                                __html: posts[index].details,
                              }}
                            ></span>
                          </div>
                          <div className="ml-auto">
                            <i className="mdi mdi-heart-outline text-muted"></i>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
                <Pagination
                  className="float-right p-2 m-b-4"
                  variant="outlined"
                  hideNextButton={true}
                  hidePrevButton={true}
                  count={length}
                  // count={10}
                  color="primary"
                  onClick={(e) => {
                    setN(e.target.outerText);
                  }}
                />
                {/* :
                    <div className="pt-5 pl-2">
                      Nothing to show
                    </div>} */}
              </div>
            </div>
          </div>
        </div>
        <Backdrop className={classes.backdrop} open={loader}>
          <CircularProgress />
        </Backdrop>
      </div>
    </div>
  );
}
